export default __webpack_public_path__ + "static/media/user.219c6415.svg";